module.exports = __webpack_public_path__ + "static/media/py.86d6fd98.webp";